/* eslint-disable react/prop-types */
import { Search as SearchIcon } from "@mui/icons-material";
import { Box, TextField, InputAdornment } from "@mui/material";
import { useState, useEffect } from "react";

interface PracticeUserSearchProps {
  value: string;
  onChange: (search: string) => void;
}

const PracticeUserSearch: React.FC<PracticeUserSearchProps> = ({
  value,
  onChange,
}) => {
  const [searchValue, setSearchValue] = useState(value);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(searchValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue, onChange]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  return (
    <Box className="flex-1 max-w-md">
      <TextField
        fullWidth
        placeholder="Search by ID, Email, Name, Phone, NPI..."
        value={searchValue}
        onChange={handleSearchChange}
        size="small"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className="text-gray-400" />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": {
              borderColor: "#E5E7EB",
            },
            "&:hover fieldset": {
              borderColor: "#D1D5DB",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#3B82F6",
            },
          },
        }}
      />
    </Box>
  );
};

export default PracticeUserSearch;
